import moment from 'moment';
import companyBenefitModal from "../../../common/modals/companyBenefitModal/companyBenefitModal.component";

class CompanyBenefitsController {

  constructor(toastr, $http, $rootScope, $stateParams, $timeout, $uibModal, $state, AuthenticationService) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.toastr = toastr;
    this.auth = AuthenticationService;
    let self = this;

    $http.get($rootScope.apiHost+"/api/admin/companies/1/benefits", {withCredentials: true}).then(function (success) {
      self.companyBenefits = success.data;
    });

  }

  addCompanyBenefit() {
    let self = this;
    var modalInstance = this.$uibModal.open(companyBenefitModal);

    modalInstance.success = function () {
      self.toastr.success("Update Success", "SUCCESS");
      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }


}

export default CompanyBenefitsController;



// WEBPACK FOOTER //
// ./client/pages/admin/company-benefits/company-benefits.controller.js